import { useCallback, useState } from "react";
//#region src/index.tsx
var useToggle = (initialValue) => {
	const [value, setValue] = useState(initialValue);
	return [
		value,
		useCallback(() => {
			setValue((p) => !p);
		}, []),
		setValue
	];
};
//#endregion
export { useToggle };
